import "../GlobalStyles.css";
import { Button, ButtonGroup} from "reactstrap";
import { useHistory } from "react-router";
import UserHeaderComponent from "../UserHeaderComponent";
import { useState, useEffect, useMemo } from "react";
import { css } from "@emotion/react";
import { useMsal } from "@azure/msal-react";
import DriverService from "../../Services/DriverService"; 
import EmployeeService from "../../Services/EmployeeService"; 
import MoonLoader from "react-spinners/MoonLoader";
import "../UserCharges/Charges.css"
import ChargePayout from "../../Models/ChargePayout";
import PayoutCard from "./PayoutCard";




export default function UserPayoutHistoryPage(){

    const history = useHistory();
    const {instance} = useMsal();

    const employeeService = useMemo(() => new EmployeeService(instance), [instance]);
    const driverService = useMemo(() => new DriverService(instance), [instance]);



    const [chargePayouts, setChargePayouts] = useState<ChargePayout[]>([])
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() =>{
        async function getPayouts(){
            try {
                setIsLoading(true)
                await GetUserPayouts();

                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching user payout data: ", error)
                setIsLoading(false);
            }
        }
        getPayouts();

   },[])

    async function GetUserPayouts(){
        try {

            const employee = await employeeService.getEmployeeByUserName()

            if(!employee){
                throw new Error(`Kan geen medewerker vinden.`)
            }
            let chargePayouts = await driverService.GetAllChargePayoutsByEmployeeContactId(employee.contactId)
            chargePayouts.sort((a, b) => a.payoutStatus - b.payoutStatus || new Date(b.payoutDate).getTime() - new Date(a.payoutDate).getTime());
            setChargePayouts(chargePayouts);

        } catch (error) {
            console.log(error)
        }
    }
    const hasPayoutsUI = chargePayouts.length !== 0 ? (
        chargePayouts.map((payout, index) => (
            <PayoutCard key={index} chargePayout={payout} />
        ))
    ) : (
        hasNoPayoutsUI()
    );

    function hasNoPayoutsUI(){
        return(
            <p>Geen uitbetalingen beschikbaar</p>
        )
    }
    
    function getButtonDiv() {
        return (
            <>
                <ButtonGroup className="fixed-bottom navbar p-0">
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/user-charges")}>
                        <i className="fas fa-arrow-left fa-2x"></i>
                    </Button>
                    <Button className="p-3 buttons-footer" style={{ backgroundColor: "#2F5FA1" }} onClick={() => history.push("/overview")}>
                        <i className="fas fa-home fa-2x"></i>
                    </Button>
                </ButtonGroup>
            </>
        );
    }
    
    function getLoadSpinner() {
        return (
            <MoonLoader
                color="black"
                loading={isLoading}
                css={
                    css`
                    display: block;
                    position: absolute;
                    left: calc(50% - 18px);
                    top: 125px; 
                    z-index: 1000`
                }
                size={25} />
        );
    }


    return (
        <>
        {getLoadSpinner()}
        <UserHeaderComponent headerText="Uitbetalingen"></UserHeaderComponent>
            {!isLoading && hasPayoutsUI}
            {getButtonDiv()}
        </>
    )
}

